var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.2832 13.8954C29.9882 13.437 29.4339 13.1535 28.833 13.1535H18.8331V2.02661C18.8331 1.47266 18.8331 0 17.1665 0C16.5817 0 16.0381 0.2698 15.7372 0.709564L0.737378 22.6326C0.428231 23.0841 0.420792 23.6469 0.716545 24.1053C1.01267 24.5633 1.56587 24.8462 2.16672 24.8462H12.1666V36.5385C12.1666 37.1955 12.6666 37.772 13.3883 37.9475C13.5367 37.983 13.6859 38 13.8332 38C14.4072 38 14.9556 37.739 15.2625 37.2904L30.2623 15.3674C30.5715 14.9159 30.5797 14.3534 30.2832 13.8954Z",
    fill: "#FF635B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningIcon);
export default __webpack_public_path__ + "static/media/lightning-icon.5c7c7dac281bacb23cc493df5e004817.svg";
export { ForwardRef as ReactComponent };